import { PropsWithChildren, useContext, useState } from 'react';
import { BsCaretDownFill, BsCaretRightFill } from 'react-icons/bs';
import { useCurrencyFormatter } from '../../../hooks/use-currency-formatter';
import { ExtraIncomeContext } from '../ExtraIncomeProvider';
import './BookingRequestDialogFooter.scss';

export type FooterProps = PropsWithChildren & {
  totalValue: number | string;
  overallBooking: number | string;
  totalHours: number;
};

export const BookingRequestDialogFooter = ({
  children,
  totalValue,
  overallBooking,
  totalHours,
}: FooterProps) => {
  const { extraIncome } = useContext(ExtraIncomeContext);
  const { formatCurrency } = useCurrencyFormatter({ placeholder: '-' });
  const [showPayDetails, setShowPayDetails] = useState(false);

  return (
    <div className="brd-footer">
      <div className="brd-footer-content">
        {/* Left side - Time and Payment info */}
        <div className="info-column">
          <div className="time-info">
            <div className="info-row d-flex justify-content-between w-100">
              <span className="label">Total Time:</span>
              <span className="value fw-bold">{totalHours}h</span>
            </div>
          </div>

          <div className="payment-info">
            <button
              type="button"
              onClick={() => setShowPayDetails(!showPayDetails)}
              className="info-row d-flex justify-content-between w-100 bg-transparent border-0"
            >
              <span className="label d-flex align-items-center">
                {showPayDetails ? (
                  <BsCaretDownFill className="me-2" />
                ) : (
                  <BsCaretRightFill className="me-2" />
                )}
                Total Pay:
              </span>
              <span className="value fw-bold">{formatCurrency(totalValue)}</span>
            </button>

            {showPayDetails && (
              <div className="payment-details">
                <div className="info-row d-flex justify-content-between mb-1 border-top pt-2">
                  <span className="label label--inside">Base Pay:</span>
                  <span className="value value--inside">{formatCurrency(overallBooking)}</span>
                </div>
                <div className="info-row d-flex justify-content-between mb-1">
                  <span className="label label--inside">Bonus:</span>
                  <span className="value value--inside">
                    {formatCurrency(extraIncome?.additionalBonus)}
                  </span>
                </div>
                <div className="info-row d-flex justify-content-between mb-2 pb-1 border-bottom">
                  <span className="label label--inside">Travel:</span>
                  <span className="value value--inside">
                    {formatCurrency(extraIncome?.travelExpenses)}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right side - Action buttons */}
        {children && <div className="action-buttons">{children}</div>}
      </div>
    </div>
  );
};
